import { FunctionComponent, memo } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { Button } from "@edgetier/components";
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons";

import { IProps } from "./user-invite-button.types";
import InviteUserForm from "./invite-user-form";

/**
 * A button that, when clicked, opens the form to invite a user in a modal.
 */
const UserInviteButton: FunctionComponent<IProps> = () => {
    const { openModal, closeModal, modalProps } = useModal();
    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>Invite User</h2>
                </ModalHeader>
                <ModalContent>
                    <InviteUserForm onInviteUser={closeModal} />
                </ModalContent>
            </Modal>
            <Button icon={faUserPlus} onClick={openModal}>
                Invite User
            </Button>
        </>
    );
};

export default memo(UserInviteButton);
